export const UPDATE_PERCENTUALE_OBIETTIVO   = 'UPDATE_PERCENTUALE_OBIETTIVO';
export const SALVA_DATI_TAKE_PROFIT 	    = 'SALVA_DATI_TAKE_PROFIT';
export const UPDATE_DATI_TAKE_PROFIT_VALIDA = 'UPDATE_DATI_TAKE_PROFIT_VALIDA';